import page from 'page'
import appStarterPg from '../../config/app-starter-pg.js'
import { showPageLogin } from './login/index.js'

export function setupAuthRoutes (baseRoute) {
  page(`${baseRoute}`, async function (context) {
    await appStarterPg()

    // TODO: show a message if that's invitation to login before accepting invite?
    showPageLogin()
  })
}
